import type { ProductOperationVo } from "@zhihaoscm/entity";

/** 详情页置顶成功后，列表页需要在返回时立即反映的短期状态键。 */
export const GOODS_OPERATION_TOP_STATE_KEY = "goods-operation-analysis-top-state";

export interface GoodsOperationTopState {
    productId: string;
    isTop: number;
}

/** 将详情页刚完成的置顶状态暂存到当前会话，避免列表先读到旧缓存数据。 */
export const rememberGoodsOperationTopState = (state: GoodsOperationTopState) => {
    if (typeof window === "undefined") return;
    try {
        window.sessionStorage.setItem(GOODS_OPERATION_TOP_STATE_KEY, JSON.stringify(state));
    } catch {
        // sessionStorage 被禁用时不影响置顶接口本身，列表仍以接口结果为准。
    }
};

/** 将置顶状态合并到当前列表，并在消费后清理，避免跨商品污染后续查询。 */
export const applyGoodsOperationTopState = (
    products: ProductOperationVo[],
    state?: GoodsOperationTopState | null
) => {
    if (!state?.productId) return products;
    return products.map(product =>
        String(product.productId) === state.productId ? { ...product, isTop: state.isTop } : product
    );
};

/** 读取并消费详情页留下的置顶状态。 */
export const consumeGoodsOperationTopState = () => {
    if (typeof window === "undefined") return null;
    try {
        const rawState = window.sessionStorage.getItem(GOODS_OPERATION_TOP_STATE_KEY);
        if (!rawState) return null;
        window.sessionStorage.removeItem(GOODS_OPERATION_TOP_STATE_KEY);
        return JSON.parse(rawState) as GoodsOperationTopState;
    } catch {
        return null;
    }
};
